import {
  Box,
  Grid,
  Typography,
  Divider,
  IconButton,
  Paper,
  InputBase,
  Button,
  CardContent,
  Card,
  Drawer,
  TextField,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import banner from "../assets/Mainbanner.png";
import logo from "../assets/logo.png";
import omm from "../assets/Omm.png";
import temple from "../assets/temple.png";
import home from "../assets/home1.png";
import k1 from "../assets/k2.png";
import god from "../assets/god.png";
import yogi from "../assets/yogi.png";
import color from "../assets/bannercolor.png";
import shiva from "../assets/shiva.png";
import siva from "../assets/siva.png";
import ganesha from "../assets/ganesha.png";
import image from "../assets/image5.png";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { motion } from "framer-motion";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Header from "./Header";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";

const services = [
  {
    icon: <span style={{ fontSize: 40 }}>📚</span>,
    title: "Learn",
    desc: "Access courses, lectures, and quizzes to master astrology.",
  },
  {
    icon: <span style={{ fontSize: 40 }}>🔮</span>,
    title: "Services",
    desc: "Book personalized consultations with verified priests & astrologers.",
  },
  {
    icon: <span style={{ fontSize: 40 }}>🕉️</span>,
    title: "Karm Kaand",
    desc: "Schedule rituals, havans, and pujas for positivity.",
  },
  {
    icon: <span style={{ fontSize: 40 }}>🛒</span>,
    title: "Shop",
    desc: "Discover spiritual accessories like Rudraksha, Yantras, and more.",
  },
  {
    icon: <span style={{ fontSize: 40 }}>🐄</span>,
    title: "Gau Daan",
    desc: "Donate and support cows through verified Gau Shalas.",
  },
  {
    icon: <span style={{ fontSize: 40 }}>🛕</span>,
    title: "Know Your Temple",
    desc: "Explore India’s spiritual heritage with temple stories & videos.",
  },
];
const primaryservices = [
  {
    icon: <AutoStoriesIcon sx={{ fontSize: 50, color: "#B71C1C" }} />,
    title: "Astrology Basics",
    desc: "Learn the core principles of astrology in simple steps. Build a strong foundation to understand celestial influences on life.",
  },
  {
    icon: <BookOnlineIcon sx={{ fontSize: 50, color: "#B71C1C" }} />,
    title: "Vedic Astrology",
    desc: "Dive into the timeless wisdom of Vedic astrology. Discover traditions, methods, and insights passed down through generations.",
  },
  {
    icon: <TrackChangesIcon sx={{ fontSize: 50, color: "#B71C1C" }} />, // chart analysis = Advanced Kundli
    title: "Advanced Kundli Reading",
    desc: "Master the art of decoding birth charts with precision. Unlock deeper insights into destiny, relationships, and career.",
  },
];
const pujaData = [
  {
    id: 1,
    title: "Sri Sathyanarayana Vratham",
    description:
      "Lord Satyanarayana is the “highest being who is an embodiment of truth”. Satyanarayana puja is performed to Lord Vishnu which bestows us with good health and wealth.",
    image: k1,
  },
  {
    id: 2,
    title: "Ganapathi Homa",
    description:
      "Ganapathi Homa is performed to remove obstacles, seek blessings of Lord Ganesha, and ensure success in all ventures.",
    image: k1,
  },
  {
    id: 3,
    title: "Lakshmi Puja",
    description:
      "Lakshmi Puja is performed to invoke Goddess Lakshmi for prosperity, wealth, and peace in the family.",
    image: k1,
  },
];
const ourservices = [
  {
    id: 1,
    title: "Spiritual Services",
    services: ["Youth | Kids | Senior Devotees"],
    image: god,
  },
  {
    id: 2,
    title: "Devotional Services",
    services: ["Daily Pujas", "Festivals"],
    image: ganesha,
  },
  {
    id: 3,
    title: "Primary Services",
    services: ["Temple Services", "Priest Services"],
    image: yogi,
  },
  {
    id: 4,
    title: "Spiritual Services",
    services: ["Youth | Kids | Senior Devotees"],
    image: ganesha,
  },
  {
    id: 5,
    title: "Primary Services",
    services: ["Temple Services", "Priest Services"],
    image: god,
  },
];

const HomePage = () => {
  const [searchOpen, setSearchOpen] = useState(false);
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -350, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 350, behavior: "smooth" });
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.3 },
    },
  };
  const itemVariantsLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
  };
  const itemVariantsRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
  };
  const cardVariants = {
    hidden: { opacity: 0, scale: 0.5, y: 50 },
    visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.8 } },
  };

  return (
    <>
      <Header />
      <Box sx={{ overflow: "hidden" }}>
        <Box
          sx={{
            backgroundImage: `url(${color})`,
            backgroundPosition: "center",
            backgroundRepeat: "repeat",
          }}
        >
          <img src={banner} alt="" style={{ width: "100%" }} />
          <Grid
            component={motion.div}
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.2 }}
            container
            sx={{ px: { xs: 2, md: 6 }, py: { xs: 2, md: 4 }, flexGrow: 1 }}
          >
            <Box sx={{ p: 2, width: "90%", mx: "auto" }}>
              {!searchOpen ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: -3,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <LocationOnIcon sx={{ color: "#6d1675", fontSize: 20 }} />
                    <Typography
                      sx={{
                        color: "#6d1675",
                        fontWeight: 700,
                        fontSize: { xs: 14, md: 15 },
                      }}
                    >
                      Telangana | Andhra Pradesh | Bengaluru | USA
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <IconButton size="small" color="primary">
                      <FacebookIcon />
                    </IconButton>
                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                    <IconButton size="small" sx={{ color: "#E4405F" }}>
                      <InstagramIcon />
                    </IconButton>
                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                    <IconButton size="small" sx={{ color: "#1DA1F2" }}>
                      <TwitterIcon />
                    </IconButton>
                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                    <IconButton size="small" sx={{ color: "#FF0000" }}>
                      <YouTubeIcon />
                    </IconButton>
                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                    <IconButton
                      size="small"
                      sx={{ color: "#555" }}
                      onClick={() => setSearchOpen(true)}
                    >
                      <SearchIcon />
                    </IconButton>
                  </Box>
                </Box>
              ) : (
                <Paper
                  component="form"
                  sx={{
                    width: "103%",
                    ml: { xs: 0, md: -2 },
                    mt: { xs: 0, md: -3.8 },
                    height: 60,
                    display: "flex",
                    alignItems: "center",
                    bgcolor: "white",

                    borderRadius: 1,
                    // boxShadow: 3,
                  }}
                >
                  <InputBase
                    placeholder="Search..."
                    sx={{ flex: 1, ml: 1 }}
                    autoFocus
                  />

                  <IconButton
                    sx={{ p: "10px", color: "#555" }}
                    onClick={() => setSearchOpen(false)}
                  >
                    <CloseIcon />
                  </IconButton>
                </Paper>
              )}
            </Box>

            <Grid size={{ xs: 12, md: 6 }} sx={{ mt: { xs: 10, md: 10 } }}>
              <img
                src={omm}
                alt="Omm"
                style={{ width: "100%", maxWidth: 100 }}
              />
              <Typography
                component={motion.div}
                variants={itemVariantsLeft}
                sx={{
                  fontSize: { xs: 20, md: 25 },
                  color: "#6d1675",
                  fontWeight: "bold",
                  mt: 2,
                }}
              >
                CONNECT WITH DIVINITY
              </Typography>
              <Typography
                component={motion.div}
                variants={itemVariantsLeft}
                sx={{
                  fontSize: { xs: 20, md: 35 },
                  color: "#333",
                  fontWeight: "bold",
                  mt: 1,
                }}
              >
                Explore the Depths of Astrology
              </Typography>
              <Typography
                component={motion.div}
                variants={itemVariantsLeft}
                sx={{ color: "#7f6b40", fontWeight: 600, mt: 2 }}
              >
                Unlock the secrets of the cosmos and discover your spiritual
                path with our expert astrologers.
              </Typography>
              <Button
                onClick={() => navigate("/learn")}
                component={motion.div}
                variants={itemVariantsLeft}
                sx={{
                  px: 5,
                  py: 2,
                  bgcolor: "#6d1675",
                  color: "#fff",
                  fontWeight: "bold",
                  mt: 4,
                  "&:hover": { bgcolor: "#5a125f" },
                }}
              >
                Learn More
              </Button>
            </Grid>
            <Grid
              component={motion.div}
              variants={itemVariantsRight}
              size={{ xs: 12, md: 6 }}
            >
              <img
                src={temple}
                alt="Temple"
                style={{ width: "100%", borderRadius: 10, marginTop: 0 }}
              />
            </Grid>
          </Grid>
        </Box>
        <Grid container spacing={5} sx={{ p: { xs: 2, md: 6 }, mt: -15 }}>
          {services.map((service, index) => (
            <Grid size={{ xs: 12, md: 4 }} key={index} sx={{ mb: 4 }}>
              <Card
                sx={{
                  textAlign: "center",
                  borderRadius: 2,
                  p: 3,
                  pt: 6,
                  position: "relative",
                  overflow: "visible",
                  ":hover": {
                    bgcolor: "#6d1675",
                    color: "#fff",
                  },
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      position: "absolute",
                      top: -40,
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: 80,
                      height: 80,
                      bgcolor: "#fff",
                      display: "flex",
                      color: "#6d1675",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "50%",
                      boxShadow: 1,
                    }}
                  >
                    {service.icon}
                  </Box>
                  <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                    {service.title}
                  </Typography>
                  <Typography sx={{ mb: 3 }}>{service.desc}</Typography>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#ffc20f",
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                  >
                    BOOK NOW
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
        <Grid
          component={motion.div}
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          container
          spacing={5}
          sx={{ p: { xs: 2, md: 6 } }}
        >
          <Grid
            component={motion.div}
            variants={itemVariantsLeft}
            size={{ xs: 12, md: 6 }}
            sx={{ mt: { xs: 0, md: 5 } }}
          >
            <Typography
              sx={{ fontWeight: "bold", fontSize: 20, color: "#6d1675" }}
            >
              About Us
            </Typography>
            <Typography
              sx={{ fontWeight: "bold", fontSize: 28, mt: 1, lineHeight: 1.1 }}
            >
              Guiding Souls, Connecting Cosmos
            </Typography>
            <Divider
              sx={{
                width: 100,
                borderBottomWidth: 5,
                borderColor: "#ffc20f",
                my: 2,
              }}
            />

            <Typography sx={{ mt: 1, textAlign: "justify" }}>
              At Jyotish Jigyasa, we blend ancient wisdom with modern technology
              to make astrology, rituals, and spirituality accessible to all.
              From personalized consultations and sacred karm kaand services to
              an exclusive LMS for astrology learners, our platform is designed
              to enlighten and empower. With authentic priests, trusted rituals,
              and a community-driven approach, we ensure every seeker finds the
              right spiritual guidance. Together, let’s embrace the divine path,
              uplift traditions, and create meaningful connections with the
              cosmos.
            </Typography>
          </Grid>
          <Grid
            component={motion.div}
            variants={itemVariantsRight}
            size={{ x: 12, md: 6 }}
          >
            <Box
              component="img"
              src={god}
              alt=""
              sx={{
                width: { xs: "100%", md: "90%" },
                // height: 400,
                borderRadius: 2,
                ml: { xs: 0, md: 2.5 }, 
              }}
            />

            <Button
              sx={{
                py: { xs: 1, md: 2 },
                px: { xs: 4, md: 10 },
                bgcolor: "#6d1675",
                color: "#fff",
                fontWeight: "bold",
                mt: { xs: 0, md: -5 },
                ml: { xs: 0, md: 13 },
                fontSize: { xs: 12, md: 14 },
                textTransform: "capitalize",
              }}
            >
              Illuminating Lives Through Ancient Wisdom
            </Button>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={5}
          sx={{
            p: 2,
            md: 6,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid size={{ xs: 12, md: 12 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{ fontWeight: "bold", fontSize: 20, color: "#6d1675" }}
              >
                Pujas
              </Typography>
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: 28,
                  mt: 1,
                  lineHeight: 1.2,
                  textAlign: "center",
                }}
              >
                Vratham Pujas
              </Typography>
              <Divider
                sx={{
                  width: 100,
                  borderBottomWidth: 5,
                  borderColor: "#ffc20f",
                  my: 2,
                }}
              />
            </Box>
          </Grid>
          <Grid container spacing={4}>
            {pujaData.map((puja) => (
              <Grid size={{ xs: 12, md: 4 }} key={puja.id}>
                <Box
                  sx={{
                    bgcolor: "#fff",
                    boxShadow: 3,
                    p: 2,
                    borderRadius: 2,
                    textAlign: "center",
                  }}
                >
                  <img
                    src={puja.image}
                    alt={puja.title}
                    style={{ height: 300 }}
                  />

                  <Typography
                    sx={{
                      fontSize: 22,
                      fontWeight: "bold",
                      textAlign: "left",
                      mt: 2,
                    }}
                  >
                    {puja.title}
                  </Typography>

                  <Typography sx={{ textAlign: "justify", mt: 2 }}>
                    {puja.description}
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mt: 2,
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        borderBottom: "1.5px solid #000",
                        ":hover": { color: "#6d1675" },
                      }}
                    >
                      Pooja Details
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        borderBottom: "1.5px solid #000",
                        ":hover": { color: "#6d1675" },
                      }}
                    >
                      Pooja Details
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid
          component={motion.div}
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          container
          spacing={5}
          sx={{ p: { xs: 2, md: 6 }, mt: 4 }}
        >
          <Grid
            component={motion.div}
            variants={itemVariantsLeft}
            size={{ xs: 12, md: 6 }}
            sx={{ mt: { xs: 0, md: 10 } }}
          >
            <Typography
              sx={{ fontWeight: "bold", fontSize: 20, color: "#6d1675" }}
            >
              For Your Special Days!
            </Typography>
            <Typography
              sx={{ fontWeight: "bold", fontSize: 28, mt: 1, lineHeight: 1.1 }}
            >
              Vedhashirvaad for Your Special Days!
            </Typography>
            <Divider
              sx={{
                width: 100,
                borderBottomWidth: 5,
                borderColor: "#ffc20f",
                my: 2,
              }}
            />

            <Typography sx={{ mt: 1, textAlign: "justify" }}>
              Mark your special occasions with the divine power of
              Vedhashirvaad. Whether it's a birthday, wedding, anniversary, or
              any milestone, receive sacred blessings through authentic Vedic
              rituals performed by experienced priests. Invoke positive energy,
              prosperity, and spiritual well-being for you and your loved ones.
              Celebrate your moments with divine grace and timeless traditions!
            </Typography>

            <Button
              sx={{
                p: 2,
                bgcolor: "#6d1675",
                color: "#fff",
                fontWeight: "bold",
                mt: 5,
              }}
            >
              Know More
            </Button>
          </Grid>
          <Grid
            component={motion.div}
            variants={itemVariantsRight}
            size={{ x: 12, md: 6 }}
          >
            <img src={god} alt="" style={{ width: "95%", borderRadius: 10 }} />
            <Button
              sx={{
                p: 2,
                height: 100,
                textAlign: "left",
                bgcolor: "#6d1675",
                color: "#fff",
                fontWeight: "bold",
                mt: { xs: 0, md: -5 },
                ml: { xs: 0, md: 5 },
                fontSize: { xs: 14, md: 15 },
              }}
            >
              Vedic Ashirvaad – Divine Blessings for a Prosperous Life!
            </Button>
          </Grid>
          <Box
            sx={{
              bgcolor: "#243549",
              p: { xs: 2, md: 8 },
              // height: 100,
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              gap: 6,
              width: "100%",
              borderRadius: 5,
            }}
          >
            {/* Pulsing Icon */}
            <Box
              sx={{
                position: "relative",
                display: "inline-flex",
                width: 60,
                height: 60,
              }}
            >
              {/* Layer 1 */}
              <motion.span
                aria-hidden
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.4)", // soft white glow
                  zIndex: 0,
                }}
                animate={{ scale: [1, 2.5], opacity: [0.6, 0] }}
                transition={{
                  repeat: Infinity,
                  duration: 2,
                  ease: "easeOut",
                  delay: 0,
                }}
              />

              {/* Layer 2 */}
              <motion.span
                aria-hidden
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.4)",
                  zIndex: 0,
                }}
                animate={{ scale: [1, 2.5], opacity: [0.6, 0] }}
                transition={{
                  repeat: Infinity,
                  duration: 2,
                  ease: "easeOut",
                  delay: 0.7,
                }}
              />

              {/* Layer 3 */}
              <motion.span
                aria-hidden
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.4)",
                  zIndex: 0,
                }}
                animate={{ scale: [1, 2.5], opacity: [0.6, 0] }}
                transition={{
                  repeat: Infinity,
                  duration: 2,
                  ease: "easeOut",
                  delay: 1.4,
                }}
              />

              {/* IconButton */}
              <IconButton
                aria-label="Play"
                size="large"
                sx={{
                  bgcolor: "#6d1675",
                  color: "white",
                  boxShadow: 3,
                  "&:hover": { bgcolor: "#5a1260" },
                  position: "relative",
                  zIndex: 1,
                  width: 60,
                  height: 60,
                }}
              >
                <PlayArrowIcon fontSize="large" />
              </IconButton>
            </Box>

            {/* Text */}
            <Typography
              sx={{
                fontSize: { xs: 16, md: 25 },
                fontWeight: "bold",
                color: "#fff",
              }}
            >
              “Discover the Essence of Hindu Spirituality – Watch, Learn, and
              Stay Connected!”
            </Typography>
          </Box>
        </Grid>
        <Grid
          variants={cardVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          container
          spacing={5}
          sx={{
            backgroundImage: `url(${color})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            // minHeight: { xs: "70vh", md: "100vh" },
            display: "flex",

            alignItems: "center",
            p: { xs: 2, md: 6 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              gap: { xs: 0, md: 15 },
              width: "100%",
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: 16, md: 20 },
                  color: "#6d1675",
                }}
              >
                Featured Courses
              </Typography>
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: 20, md: 28 },
                  mt: 1,
                  lineHeight: 1.2,
                  color: "#fff",
                  textAlign:{xs:'center',md:'left'}
                }}
              >
                Begin your spiritual journey with expert-designed courses.
                <br /> Learn astrology step by step, from basics to advanced
                practices.
              </Typography>
              <Divider
                sx={{
                  width: 100,
                  borderBottomWidth: 5,
                  borderColor: "#ffc20f",
                  my: 2,
                }}
              />
            </Box>
            <Box
              sx={{
                position: "relative",
                display: "inline-flex",
                width: 60,
                height: 60,
              }}
            >
              {[0, 0.7, 1.4].map((delay, index) => (
                <motion.span
                  key={index}
                  aria-hidden
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    background: "#6d1675",
                    zIndex: 0,
                  }}
                  animate={{ scale: [1, 2.5], opacity: [0.6, 0] }}
                  transition={{
                    repeat: Infinity,
                    duration: 2,
                    ease: "easeOut",
                    delay,
                  }}
                />
              ))}

              <IconButton
                aria-label="Play"
                size="large"
                sx={{
                  bgcolor: "#6d1675",
                  color: "white",
                  boxShadow: 3,
                  "&:hover": { bgcolor: "#5a1260" },
                  position: "relative",
                  zIndex: 1,
                  width: 60,
                  height: 60,
                }}
              >
                <PlayArrowIcon fontSize="large" />
              </IconButton>
            </Box>
          </Box>

          {primaryservices.map((service, index) => (
            <Grid
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.2 }}
              size={{ xs: 12, md: 4 }}
              key={index}
            >
              <motion.div
                variants={cardVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
              >
                <Card
                  sx={{
                    textAlign: "center",
                    borderRadius: 2,
                    p: 3,
                    height: 270,
                    position: "relative",
                    overflow: "visible",
                    ":hover": {
                      bgcolor: "rgba(0, 0, 0, 0.7)",
                      color: "#fff",
                    },
                  }}
                >
                  <CardContent>
                    <Typography sx={{ mt: -2 }}>{service.icon}</Typography>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: "bold", mb: 2, mt: 2 }}
                    >
                      {service.title}
                    </Typography>
                    <Typography sx={{ mb: 3 }}>{service.desc}</Typography>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          position: "absolute",
                          bottom: 30,
                          fontWeight: "bold",
                          color: "#B71C1C",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        KNOW MORE
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
        <Grid container sx={{ p: { xs: 2, md: 6 } }}>
          <Box
            sx={{
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: { xs: 16, md: 20 },
                color: "#6d1675",
              }}
            >
              Service
            </Typography>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: { xs: 24, md: 28 },
                mt: 1,
                lineHeight: 1.2,
                color: "black",
              }}
            >
              Our Services
            </Typography>
            <Divider
              sx={{
                width: 100,
                borderBottomWidth: 5,
                borderColor: "#ffc20f",
                my: 2,
                mx: "auto",
              }}
            />
          </Box>

          <Box sx={{ position: "relative", width: "100%" }}>
            <IconButton
              onClick={scrollLeft}
              sx={{
                position: "absolute",
                left: 0,
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 10,
                bgcolor: "white",
                "&:hover": { bgcolor: "#ffc20f" },
              }}
            >
              <ArrowBackIosNewIcon />
            </IconButton>

            {/* Right Arrow */}
            <IconButton
              onClick={scrollRight}
              sx={{
                position: "absolute",
                right: 0,
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 10,
                bgcolor: "white",
                "&:hover": { bgcolor: "#ffc20f" },
              }}
            >
              <ArrowForwardIosIcon />
            </IconButton>

            <Box
              ref={scrollRef}
              sx={{
                display: "flex",
                gap: 3,
                overflowX: "auto",
                scrollBehavior: "smooth",
                p: { xs: 2, md: 5 },

                "&::-webkit-scrollbar": { display: "none" },
                "-ms-overflow-style": "none",
                "scrollbar-width": "none",
              }}
            >
              {ourservices.map((course, index) => (
                <motion.div
                  key={index}
                  style={{ flex: "0 0 calc((100% - 2*16px)/3)" }}
                >
                  <Card
                    sx={{
                      width: { xs: 300, md: 350 },
                      height: "100%",
                      borderRadius: 3,
                      boxShadow: 3,
                      cursor: "pointer",
                      overflow: "hidden",
                      textAlign: "center",
                    }}
                  >
                    {/* Image with overlay */}
                    <Box
                      sx={{
                        position: "relative",
                        height: { xs: 180, md: 200 },
                        overflow: "hidden",
                      }}
                    >
                      <motion.img
                        src={course.image}
                        alt={course.title}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        whileHover={{ scale: 1.2 }}
                        transition={{ duration: 0.3 }}
                      />

                      <Box
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          bgcolor: "rgba(255, 255, 255, 0)",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            bgcolor: "rgba(255, 255, 255, 0.6)",
                          },
                        }}
                      >
                        <Box
                          component="img"
                          src={omm}
                          alt="Omm"
                          sx={{
                            width: 100,
                            height: 100,
                            opacity: 0,
                            transition: "all 0.3s ease",
                            "&:hover": { opacity: 1 },
                          }}
                        />
                      </Box>
                    </Box>

                    <CardContent>
                      <Typography
                        variant="h6"
                        sx={{ fontWeight: "bold", color: "#6d1675", mb: 1 }}
                      >
                        {course.title}
                      </Typography>
                      <Typography sx={{ mb: 2, lineHeight: 1.6, fontSize: 16 }}>
                        {course.services}
                      </Typography>
                    </CardContent>
                  </Card>
                </motion.div>
              ))}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#ffc20f",
                  color: "#000",
                  fontWeight: "bold",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#6d1675",
                    color: "#fff",
                  },
                }}
              >
                Get Course Details →
              </Button>
            </Box>
          </Box>
        </Grid>
        <Box
          sx={{
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Box
            component="img"
            src={shiva}
            alt="background"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              textAlign: "center",
            }}
          />

          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              bgcolor: "rgba(0,0,0,0.6)",
            }}
          >
            <Box
              sx={{
                mt: { xs: 5, md: 10 },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: 16, md: 20 },
                  color: "#6d1675",
                }}
              >
                Contact Us
              </Typography>
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: 24, md: 28 },
                  mt: 1,
                  lineHeight: 1.2,
                  color: "#fff",
                }}
              >
                Get In Touch
              </Typography>
              <Divider
                sx={{
                  width: 100,
                  borderBottomWidth: 5,
                  borderColor: "#ffc20f",
                  my: 2,
                  mx: "auto",
                }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              position: "relative",
              backgroundColor: "#fff",
              borderTopLeftRadius: "50% 50px",
              borderTopRightRadius: "50% 50px",
              mt: { xs: 10, md: -20 },
              pt: 8,
              pb: 6,
            }}
          >
            <Grid
              container
              sx={{ justifyContent: "center", mt: { xs: -15, md: -20 } }}
            >
              <Grid size={{ xs: 10, md: 10 }} sx={{}}>
                <Card
                  elevation={6}
                  sx={{
                    borderRadius: 3,
                    overflow: "hidden",
                  }}
                >
                  <CardContent sx={{ p: { xs: 2, md: 4 } }}>
                    <Grid container spacing={3} alignItems="stretch">
                      {/* Left: Form */}
                      <Grid size={{ xs: 12, md: 7 }}>
                        <TextField
                          fullWidth
                          label="Name"
                          variant="outlined"
                          margin="normal"
                        />
                        <TextField
                          fullWidth
                          label="Email"
                          type="email"
                          variant="outlined"
                          margin="normal"
                        />
                        <TextField
                          fullWidth
                          label="Phone"
                          type="tel"
                          variant="outlined"
                          margin="normal"
                        />
                        <TextField
                          fullWidth
                          label="Your Message"
                          multiline
                          rows={4}
                          variant="outlined"
                          margin="normal"
                        />
                        <Box textAlign="left" mt={2}>
                          <Button
                            variant="contained"
                            sx={{
                              bgcolor: "#ffc20f",
                              color: "#fff",
                              fontWeight: "bold",
                              px: 4,
                              py: 1,
                              borderRadius: 2,
                              boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
                              "&:hover": { bgcolor: "#b91c1c" },
                            }}
                          >
                            Send Now
                          </Button>
                        </Box>
                      </Grid>

                      <Grid size={{ xs: 12, md: 5 }}>
                        <Box
                          sx={{
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={siva}
                            alt="Shiva"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "12px",
                            }}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Box sx={{ p: { xs: 2, md: 10 } }}>
          <Grid container>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{ bgcolor: "#6d1675", p: { xs: 2, md: 8 } }}
            >
              <Box
                sx={{
                  display: "flex",

                  flexDirection: "column",

                  height: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "bold",
                    fontSize: { xs: 16, md: 23 },
                    color: "#fff",
                  }}
                >
                  Register as a Priest
                </Typography>

                <Divider
                  sx={{
                    width: 100,
                    borderBottomWidth: 5,
                    borderColor: "#ffc20f",
                    my: 1,
                    // mx: "auto",
                  }}
                />

                <Typography
                  sx={{
                    fontSize: { xs: 14, md: 16 },
                    mt: 1,
                    lineHeight: 1.5,
                    color: "#fff",
                    // maxWidth: 400,
                  }}
                >
                  Join Puja Services and offer your expertise to devotees
                  worldwide. Get a dedicated profile, receive online bookings,
                  and earn through spiritual service. Expand your reach and
                  serve more people.
                </Typography>

                <Button
                  variant="contained"
                  sx={{
                    mt: 5,
                    bgcolor: "#ffc20f",
                    color: "#fff",
                    fontWeight: "bold",
                    px: 4,
                    py: 1,
                    borderRadius: 2,
                    width: 180,
                    boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
                    "&:hover": { bgcolor: "#b91c1c" },
                  }}
                >
                  Send Now
                </Button>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Box
                component="img"
                src={image}
                alt="contact"
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default HomePage;

